// extracted by css-extract-rspack-plugin
export default {"group":"vW3aXLkHe5sUY0E6"};